export const CONFIRM_PHONE = 'customer/CONFIRM_PHONE';
export const CONFIRM_PHONE_CODE = 'customer/CONFIRM_PHONE_CODE';
export const SELECT_LANGUAGE = 'customer/SELECT_LANGUAGE';

export const START_EMAIL_EDIT = 'customer/START_EMAIL_EDIT';
export const CONFIRM_EMAIL = 'customer/CONFIRM_EMAIL';

export const SET_EMAIL_MARKETING_CONSENT = 'customer/SET_EMAIL_MARKETING_CONSENT';
export const SET_SMS_MARKETING_CONSENT = 'customer/SET_SMS_MARKETING_CONSENT';
export const CONFIRM_SET_GUEST = 'customer/CONFIRM_SET_GUEST';
export const GUEST_ORDER_LOGIN_ANONYMOUSLY = 'customer/GUEST_ORDER_LOGIN_ANONYMOUSLY';
